export default __webpack_public_path__ + "static/media/ft-homepage.94b0426d.png";